
import { useApiStore } from "@/stores/apiStore";
import { useAuthStore } from "@/stores/authStore";
import { useToastStore } from "@/stores/toastStore";
import { useSiteStore } from "@/stores/siteStore";
import { defineComponent, Ref, ref } from "vue";
import { storeToRefs } from "pinia";
import moment from "moment-timezone";
import { AxiosError } from "axios";
import COUNTRIES_DATA from "@/utils/Countries";
import { FormatBytes } from "@/utils/Utilities";
interface RoleTableData {
	id: number;
	name: string;
	text: string;
	value: number;
	global: boolean;
}
export default defineComponent({
	setup() {
		const file: any = ref(null);
		const countries = COUNTRIES_DATA.map((country) => {
			return {
				text: country,
				value: country
			};
		});
		const api = useApiStore();
		const authStore = useAuthStore();
		const toast = useToastStore();
		const formatBytes = FormatBytes;
		const { user }: { user: Ref<AuthUser | null> } = storeToRefs(authStore);
		const authUser = user;
		const siteStore = useSiteStore();
		return {
			api,
			authStore,
			authUser,
			moment,
			countries,
			file,
			formatBytes,
			toast,
			siteStore
		};
	},
	name: "imdex-site",
	data() {
		return {
			selectAllFiles: false,
			fileSearchTerm: "",
			deleteDialog: false,
			siteDeleteDialog: false,
			tab: 0,
			createLoading: false,
			tableLoading: false,
			showOption: false,
			// siteData: {
			//     columns: ['site','contributor', 'viewer', 'none'],
			//     tableData: [],
			//     options: {}
			// },
			site: {
				name: "",
				description: "",
				country: "",
				isSysAdminOnly: false
			},
			roleSelect: "New User",
			userRole: "New User",
			availableRoles: [] as RoleTableData[],
			allRoles: [] as RoleTableData[],
			sites: [],
			users: [] as AuthUser[],
			userPermissionTableData: {
				columns: ["name", "contributor", "viewer", "remove"],
				tableData: [],
				options: {
					columns: {
						remove: {
							maxWidth: "5%"
						}
					}
				}
			},
			storageTableData: {
				columns: [
					"select",
					"filename",
					"uploaded",
					"uploaded_by",
					"source",
					"size",
					"delete"
				], // eslint-disable-next-line
				tableData: [] as any[],
				options: {
					thead: {
						background: "#E6E8E9"
					},
					rows: {
						spacing: "5px"
					},
					columns: {
						select: {
							maxWidth: "2%",
							filterable: false,
							sortable: false
						},
						delete: {
							maxWidth: "5%",
							filterable: false,
							sortable: false
						}
					}
				}
			},
			searchUser: null,
			userPermissionSearchTerm: "",
			userPermissionSearchRole: "", // eslint-disable-next-line
			uploadedBySearchTerm: "",
			storageFiles: [] as any[],
			fileDateRange: "All",
			fileUploadedBy: "All",
			availableDateRanges: [
				{ text: this.$t("import.prevUploadDialog.today"), value: "Today" },
				{ text: this.$t("import.prevUploadDialog.thisWeek"), value: "This Week" },
				{ text: this.$t("import.prevUploadDialog.pastMonth"), value: "Past Month" },
				{ text: this.$t("import.prevUploadDialog.ytd"), value: "YTD" },
				{ text: this.$t("import.prevUploadDialog.all"), value: "All" }
			],
			siteUsers: [],
			deleteFileIds: [] as any,
			totalSizeOfUploadedFiles: 0,
			storageTableRenderKey: 0,
			isPageChanging: false
		};
	},
	mounted() {
		this.getStorageFiles();
		this.getSite();
		this.getSiteUsers();
		this.getRoles();
		this.getUsers();
	},
	computed: {
		totalSizeText(): any {
			const textArray = this.formatBytes(this.totalSizeOfUploadedFiles).split(" ");

			return `${textArray[0]} <span class="byte-size">${textArray[1]}</span>`;
		},
		selectedFiles(): any {
			return this.storageTableData.tableData.filter((item: any) => {
				return item.selected;
			});
		},
		// eslint-disable-next-line
		searchUsers(): any {
			// eslint-disable-next-line
			return [
				...this.users
					.filter((item: any) => {
						return !this.siteUsers.some((siteUser: any) => siteUser.userId == item.id);
					})
					.map((item: any) => {
						return { text: item.name, value: item.id };
					})
			];
		},
		searchFileUsers(): any {
			const uploadedByUsers = this.storageFiles
				.map((file) => {
					return {
						text: file.uploaded_by,
						value: file.uploaded_by
					};
				})
				.filter((user, index, currentArr) => {
					return (
						index ===
						currentArr.findIndex((item) => {
							return item.value === user.value;
						})
					);
				});

			uploadedByUsers.push({
				text: this.$t("site.all"),
				value: "All"
			});

			return uploadedByUsers;
		},
		isAdmin(): boolean {
			if (this.authUser != null) {
				return (
					this.authUser.globalRole.name == "Administrator" ||
					this.authUser.globalRole.name == "System Administrator"
				);
			} else {
				return false;
			}
		},
		isSystemAdmin(): boolean {
			if (this.authUser != null) {
				return this.authUser.globalRole.name == "System Administrator";
			} else {
				return false;
			}
		},
		editing() {
			return this.$route.params.id != null;
		}
	},
	methods: {
		toggleSelectAllFiles() {
			this.isPageChanging = true;
			const currentPageFiles = (this.$refs.storageTable as any).getCurrentPageItems();
			const filesSelectedComparedToCurrentPage = currentPageFiles.filter((file: any) => {
				const foundFile = this.selectedFiles.find(
					(selected: any) => selected.fileId == file.fileId
				);

				return foundFile ? true : false;
			});

			if (filesSelectedComparedToCurrentPage.length === currentPageFiles.length) {
				this.selectAllFiles = true;
				this.isPageChanging = false;
			} else {
				this.selectAllFiles = false;
			}
		},
		validateSiteInputs() {
			if (!this.site.name || (this.site.name && !this.site.name.trim())) {
				this.createLoading = false;
				this.toast.toast({
					title: this.$t("toastGeneralError"),
					dismissable: false,
					message: this.$t("site.errorInputBlank"),
					type: "error"
				});

				return false;
			}

			return true;
		},
		async confirmDeleteFiles() {
			this.deleteDialog = false;

			if (!this.deleteFileIds.length) {
				return;
			}

			try {
				this.deleteFileIds.forEach(async (deleteId: string) => {
					// #TODO: Change this, temporary just to check functionality working
					// need to check if blob or has db entry id another way
					const url =
						deleteId.indexOf("/") !== -1
							? `/upload-dataset/delete-blob?blobName=${deleteId}`
							: `/upload-dataset/delete?rawFileId=${deleteId}`;

					await this.api.delete(url);
				});

				this.createLoading = false;

				this.toast.toast({
					title: this.$t("toastGeneralSuccess"),
					dismissable: false,
					message: this.$t("site.toastFileDeleted"),
					type: "success"
				});

				this.storageFiles = this.storageFiles.filter(
					(file) => !this.deleteFileIds.includes(file.fileId)
				);

				this.filterFiles(false);

				const updatedTotalFileSize = this.storageFiles.reduce((acc, curr) => {
					return acc + curr.size;
				}, 0);

				this.totalSizeOfUploadedFiles = updatedTotalFileSize;
				this.deleteFileIds = [];
			} catch (e) {
				this.createLoading = false;
				this.toast.toast({
					title: this.$t("toastGeneralError"),
					dismissable: false,
					message: this.$t("site.errorProblemDeleting"),
					type: "error"
				});
			}
		},
		async getUsers() {
			const { data } = await this.api.get("/user/read");
			this.users = data;
		},
		async getSite() {
			if (!this.editing) return;
			const route = "/site/read/" + this.$route.params.id;
			try {
				const { data } = await this.api.get(route);
				this.site = data;
			} catch (e) {
				console.log(e);
				this.$router.go(-1);
				// this.authStore.logout();
			}
		},
		async getStorageFiles() {
			if (!this.$route.params.id) return;
			const route = "/upload-dataset/read?site=" + this.$route.params.id;

			try {
				const { data } = await this.api.get(route);

				this.totalSizeOfUploadedFiles = data.totalSize;
				// eslint-disable-next-line
				const storageFiles = data.files.map((storageFile: any) => {
					const formattedFile: any = {};

					formattedFile.fileId = storageFile.id ? storageFile.id : storageFile.name;
					formattedFile.filename = storageFile.id
						? storageFile.fileName
						: storageFile.name;
					formattedFile.size = storageFile.size;

					if (storageFile.id) {
						formattedFile.uploaded = moment(storageFile.createdAt);
						formattedFile.uploaded_by = storageFile.uploadedBy.name;
						formattedFile.source = "Mineportal";
					} else {
						formattedFile.uploaded = moment(new Date());
						formattedFile.uploaded_by = this.$t("site.n/a");
						formattedFile.source = this.$t("site.blobStorage");
					}

					formattedFile.selected = false;

					return formattedFile;
				});

				this.storageFiles = storageFiles;
				this.storageTableData.tableData = this.storageFiles;
			} catch (e) {
				console.log(e);
			}
		},
		async deleteSite() {
			await this.api.delete(`/site/delete/${this.$route.params.id}`);
			this.siteStore.GET_SITES();

			if (
				this.siteStore.activeSite &&
				this.siteStore.activeSite["id"] == this.$route.params.id
			) {
				this.siteStore.SET_TO_DEFAULT_SITE();
			}

			this.$router.go(-1);
		},
		async getRoles() {
			const { data } = await this.api.get("/role/read");

			const tmpAllRoles = [] as RoleTableData[];
			for (const item of data) {
				tmpAllRoles.push({
					id: item.id,
					name: item.name,
					text:
						typeof this.$t === "function" // cypress test work-around - this.$t is not a function otherwise
							? this.$t(`site.${item.name.toLowerCase()}`)
							: item.name,
					value: item.id,
					global: item.global
				});
			}
			this.allRoles = tmpAllRoles;
			this.availableRoles = this.allRoles.filter((item: any) => {
				const roleName = item.name.toLowerCase();
				return roleName === "contributor" || roleName === "viewer";
			});
		},
		async getSiteUsers() {
			try {
				if (!this.$route.params.id) return;
				const route = `/site-user/read?siteId=${this.$route.params.id}`;
				const { data } = await this.api.get(route);

				const siteUsers = data
					.filter((siteUser: any) => {
						return siteUser.user; // siteUser site is now set to null rather than a "none" role with empty permissions
					})
					.map((siteUser: any) => {
						const roleObj: any = {
							name: siteUser.user.name,
							userId: siteUser.user._id, // _id because it is nested result
							contributor: false,
							viewer: false
						};

						const currentRole = siteUser.role.name.toLowerCase();
						roleObj[currentRole] = true;

						return roleObj;
					});

				this.siteUsers = siteUsers;
				this.userPermissionTableData.tableData = this.siteUsers;
			} catch (e) {
				console.log(e);
			}
		},

		async submitEditSite() {
			this.createLoading = true;

			if (!this.validateSiteInputs()) return;

			try {
				await this.api.put({
					endpoint: "/site/update/" + this.$route.params.id,
					post: this.site
				}); // eslint-disable-next-line
				if (
					this.authUser!.globalRole.name == "Administrator" ||
					this.authUser!.globalRole.name == "System Administrator"
				) {
					if (this.roleSelect != this.userRole) {
						// eslint-disable-next-line
						let roleId: any = this.availableRoles.filter(
							(item: any) => item.name == this.roleSelect
						)[0];
						const rolePost = {
							userId: this.$route.params.id,
							roleId: roleId.id
						};
						await this.api.post({
							endpoint: "/user/assign-role",
							post: rolePost
						});
					}
				}
				this.createLoading = false;

				this.toast.toast({
					title: this.$t("toastGeneralSuccess"),
					dismissable: false,
					message: this.$t("site.toastSiteUpdated"),
					type: "success"
				});
				// this.$router.go(-1)
			} catch (e) {
				this.createLoading = false;

				this.toast.toast({
					title: this.$t("toastGeneralError"),
					dismissable: false,
					message: this.$t("site.errorEditingSite"),
					type: "error"
				});
			}
		},
		async submitCreateSite() {
			this.createLoading = true;

			if (!this.validateSiteInputs()) return;

			try {
				console.log("site data: ", this.site);
				await this.api.post({ endpoint: "/site/create", post: this.site });
				this.siteStore.GET_SITES();
				this.createLoading = false;
				this.$router.go(-1);
			} catch (e) {
				if (e instanceof AxiosError) {
					this.createLoading = false;

					this.toast.toast({
						title: this.$t("toastGeneralError"),
						dismissable: false,
						message: e.response
							? e.response.data.message
							: this.$t("site.errorCreatingSite"),
						type: "error"
					});
				}
			}
		}, // eslint-disable-next-line
		async updateSitePermission(row: any, type: string) {
			try {
				const post: any = {
					userId: row.userId,
					siteId: this.$route.params.id,
					roleName: type === "none" ? "none" : undefined,
					roleId: undefined
				};

				if (type !== "none") {
					const role: any = this.allRoles.find(
						(item: any) => item.name.toLowerCase() === type
					);

					if (role) {
						post.roleId = role.id;
					}
				}

				await this.api.post({ endpoint: "/user/assign-role", post });
			} catch (e) {
				console.log(e);
			}

			if (type === "none") {
				// eslint-disable-next-line
				this.siteUsers = this.siteUsers.filter(
					(siteUser: any) => siteUser.userId != row.userId
				);
				this.userPermissionTableData.tableData = this.siteUsers;
			} else {
				row.contributor = false;
				row.viewer = false;
				row[type] = true;
			}
		},
		async submitAddUserToSite() {
			this.createLoading = true;

			if (!this.userPermissionSearchRole || !this.userPermissionSearchTerm) {
				this.createLoading = false;
				this.toast.toast({
					title: this.$t("toastGeneralError"),
					dismissable: false,
					message: this.$t("site.missingUserOrRole"),
					type: "error"
				});

				return;
			}

			try {
				const post = {
					userId: this.userPermissionSearchTerm,
					roleId: this.userPermissionSearchRole,
					siteId: this.$route.params.id
				};

				await this.api.post({ endpoint: "/user/assign-role", post });

				this.createLoading = false;
				this.toast.toast({
					title: this.$t("toastGeneralSuccess"),
					dismissable: false,
					message: this.$t("site.toastUserAddedToSite"),
					type: "success"
				});

				this.getSiteUsers();
				this.userPermissionSearchRole = "";
				this.userPermissionSearchTerm = "";
			} catch (error) {
				this.createLoading = false;

				this.toast.toast({
					title: this.$t("toastGeneralError"),
					dismissable: false,
					message: this.$t("site.errorAddingUser"),
					type: "error"
				});
			}
		},
		async filterFiles(refreshTable = true) {
			let filtered = this.storageFiles;

			if (this.fileSearchTerm) {
				filtered = filtered.filter(
					(file) =>
						file.filename.toLowerCase().indexOf(this.fileSearchTerm.toLowerCase()) != -1
				);
			}

			if (this.fileUploadedBy && this.fileUploadedBy !== "All") {
				filtered = filtered.filter((file) => {
					return file.uploaded_by.toLowerCase() === this.fileUploadedBy.toLowerCase();
				});
			}

			if (this.fileDateRange) {
				filtered = filtered.filter((file) => {
					const uploadedTime = moment(file.uploaded).startOf("day");
					const now = moment().startOf("day");

					switch (this.fileDateRange) {
						case "Today":
							return uploadedTime.isSame(moment(), "day");
						case "This Week":
							return uploadedTime.isSameOrAfter(now.subtract(1, "w"));
						case "Past Month":
							return uploadedTime.isSameOrAfter(now.subtract(1, "month"));
						case "YTD":
							return uploadedTime.isSameOrAfter(now.subtract(1, "year"));
						default:
							return true;
					}
				});
			}

			this.storageTableData.tableData = filtered;

			if (refreshTable) {
				this.storageTableRenderKey++;
			}
		}
	},
	watch: {
		fileDateRange() {
			this.filterFiles();
		},
		fileSearchTerm() {
			this.filterFiles();
		},
		fileUploadedBy() {
			this.filterFiles();
		},
		storageTableData: {
			deep: true,
			handler(v) {
				this.$nextTick(function () {
					if (this.$refs.storageTable) {
						const currentPageFiles = (
							this.$refs.storageTable as any
						).getCurrentPageItems();

						const currentPageSelected = v.tableData.filter((item: any) => {
							const foundCurrentPageFile = currentPageFiles.find(
								(file: any) => file.fileId == item.fileId
							);

							return foundCurrentPageFile && item.selected;
						});

						const allSelected = v.tableData.filter((item: any) => {
							return item.selected;
						});

						if (this.selectedFiles.length == 0) {
							this.selectAllFiles = false;
							this.deleteFileIds = [];
						} else if (currentPageSelected.length == currentPageFiles.length) {
							this.selectAllFiles = true;
							this.deleteFileIds = allSelected.map((file: any) => file.fileId);
						} else {
							this.deleteFileIds = allSelected.map((file: any) => file.fileId);
						}
					}
				});
			}
		},
		selectAllFiles(v) {
			const currentPageFiles = (this.$refs.storageTable as any).getCurrentPageItems();

			if (this.selectedFiles.length == 0) {
				this.storageFiles = this.storageTableData.tableData.map((item) => {
					const foundFile = currentPageFiles.find(
						(file: any) => file.fileId == item.fileId
					);

					if (foundFile) {
						return { ...item, selected: v };
					} else {
						return item;
					}
				});

				this.storageTableData.tableData = this.storageFiles;
			} else if (this.selectedFiles.length > 0) {
				this.storageFiles = this.storageTableData.tableData.map((item) => {
					const foundSelectedFile = this.selectedFiles.find(
						(file: any) => file.fileId == item.fileId
					);
					const foundCurrentPageFile = currentPageFiles.find(
						(pageFile: any) => pageFile.fileId == item.fileId
					);

					if (foundSelectedFile && foundCurrentPageFile && !this.isPageChanging) {
						return { ...item, selected: v };
					}

					if (!foundSelectedFile && foundCurrentPageFile) {
						return { ...item, selected: v };
					}

					return item;
				});
			}

			this.isPageChanging = false;
			this.storageTableData.tableData = this.storageFiles;
		}
	}
});
